<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M5.71512 13.9884L0.572266 15.4284L2.01227 10.2856L11.4294 0.91417C11.5358 0.805317 11.663 0.718827 11.8032 0.659779C11.9436 0.60073 12.0943 0.570312 12.2466 0.570312C12.3988 0.570312 12.5495 0.60073 12.6899 0.659779C12.8301 0.718827 12.9573 0.805317 13.0637 0.91417L15.0866 2.94845C15.1936 3.05469 15.2787 3.18111 15.3367 3.32036C15.3948 3.45963 15.4246 3.60901 15.4246 3.75988C15.4246 3.91075 15.3948 4.06013 15.3367 4.1994C15.2787 4.33867 15.1936 4.46507 15.0866 4.57131L5.71512 13.9884Z"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
